import React, { useState, useEffect } from "react";

function DrinksNonAlc() {

    const [coldDrinks, setColdDrinks] = useState([]);
    const [wines, setWines] = useState([]);
    const [hotDrinks, setHotDrinks] = useState([]);

    useEffect(() => {
        fetch('https://strapi.restauracjasamiswoi.pl/api/categories?populate=menu_items')
        .then(response => response.json())
        .then(data => {
            const coldDrinksCategory = data.data.find(item => item.name === 'NAPOJE ZIMNE');
            const winesCategory = data.data.find(item => item.name === 'WINO');
            const hotDrinksCategory = data.data.find(item => item.name === 'NAPOJE GORĄCE');

            if (coldDrinksCategory) {
                setColdDrinks(coldDrinksCategory.menu_items);
            };

            if (winesCategory) {
                setWines(winesCategory.menu_items);
            };

            if (hotDrinksCategory) {
                setHotDrinks(hotDrinksCategory.menu_items);
            };

        });

    }, []);

    return (

        <div className="container-fluid pt-4">
            <div className="container">
        <p className="menu-item-title-font fs-1 fw-bold pt-5">ZIMNE NAPOJE</p>
        <hr/>
        {coldDrinks.map((coldDrink) => (
            <div key={coldDrink.id} className="container">
                <div className="dish-name-container d-flex justify-content-between">
                    <p className="menu-item-title-font fs-5 m-0">{coldDrink.name}</p>
                    <p className="fs-5 m-0">{coldDrink.price}zł</p>
                </div>
                <p className="ingridients-container fs-6 m-0 fw-lighter">{coldDrink.ingredients}</p>
                <div className="mb-3 mt-3 divide-line"/>
            </div>
        ))}
        </div>
        <div className="container">
        <p className="menu-item-title-font fs-1 fw-bold pt-5">WINA</p>
        <hr/>
        {wines.map((wine) => (
            <div key={wine.id} className="container">
                {wine.name && wine.price && (
                    <div className="dish-name-container d-flex justify-content-between">
                        <p className="menu-item-title-font fs-5 m-0">{wine.name}</p>
                        <p className="fs-5 m-0">{wine.price}zł</p>
                    </div>
                )}
                <p className="ingridients-container fs-6 m-0 fw-lighter">{wine.ingredients}</p>
                <div className="mb-3 mt-3 divide-line"/>
            </div>
        ))}
        </div>
        <div className="container">
        <p className="menu-item-title-font fs-1 fw-bold pt-5">NAPOJE GORĄCE</p>
        <hr/>
        {hotDrinks.map((hotDrink) => (
            <div key={hotDrink.id} className="container">
                <div className="dish-name-container d-flex justify-content-between">
                    <p className="menu-item-title-font fs-5 m-0">{hotDrink.name}</p>
                    <p className="fs-5 m-0">{hotDrink.price}zł</p>
                </div>
                <p className="ingridients-container fs-6 m-0 fw-lighter">{hotDrink.ingredients}</p>
                <div className="mb-3 mt-3 divide-line"/>
            </div>
        ))}
        </div>
        </div>
    )
}

export default DrinksNonAlc;